import { combineReducers } from 'redux';

import effectiveTaxRateReducer from '../viewEffectiveTaxRatePage/store/reducer';
import taxExpenseReducer from '../viewTaxExpensePage/store/reducer';
import configurationSettingsReducer from '../configurationSettings/store/reducer';
import customReportsReducer from '../customReports/store/reducer';

export default combineReducers({
  effectiveTaxRate: effectiveTaxRateReducer,
  taxExpense: taxExpenseReducer,
  configurationSettings: configurationSettingsReducer,
  customReports: customReportsReducer,
});
